import {
  ADD_DOCUMENT,
  ADD_FOLDER,
  DELETE_FOLDER,
  FETCH_FOLDER,
  REMOVE_DOCUMENT,
  UPDATE_DOCUMENT,
  UPDATE_FOLDER,
  HIGHLIGHT_DOCUMENT
} from 'components/documents/actions';

export default function(state = {}, action) {
  switch (action.type) {
  case ADD_DOCUMENT: {
    const { document } = action.payload;
    const key = currentFolderKey(document.marketing);

    return {
      ...state,
      [key]: addItemToFolder({ ...state[key] }, document)
    };
  }
  case ADD_FOLDER: {
    const { folder } = action.payload;
    const key = currentFolderKey(folder.marketing);

    return {
      ...state,
      [key]: addItemToFolder({ ...state[key] }, folder)
    };
  }
  case REMOVE_DOCUMENT: {
    const { document } = action.payload;
    const newState = {};

    if (state.currentMarketingFolder) {
      newState.currentMarketingFolder = filterFromFolder({ ...state.currentMarketingFolder }, document);
    }
    if (state.currentNonMarketingFolder) {
      newState.currentNonMarketingFolder = filterFromFolder({ ...state.currentNonMarketingFolder }, document);
    }

    return newState;
  }
  case DELETE_FOLDER: {
    const folder = action.payload;
    const newState = {};


    if (state.currentMarketingFolder) {
      newState.currentMarketingFolder = filterFromFolder({ ...state.currentMarketingFolder }, folder);
    }
    if (state.currentNonMarketingFolder) {
      newState.currentNonMarketingFolder = filterFromFolder({ ...state.currentNonMarketingFolder }, folder);
    }

    return newState;
  }
  case FETCH_FOLDER:
    return {
      ...state,
      [currentFolderKey(action.payload.marketing)]: action.payload
    };
  case UPDATE_DOCUMENT: {
    const { document } = action.payload;
    const key = currentFolderKey(document.marketing);

    return {
      ...state,
      [key]: updateDocumentInFolder({ ...state[key] }, document)
    };
  }
  case UPDATE_FOLDER: {
    const { folder } = action.payload;
    const key = currentFolderKey(folder.marketing);

    return {
      ...state,
      [key]: updateFolder({ ...state[key] }, folder)
    };
  }
  case HIGHLIGHT_DOCUMENT: {
    const documentId = action.payload;

    return {
      ...state,
      ["selectedDoc"]: documentId
    };
  }
  default:
    return state;
  }
}

function currentFolderKey(marketing) {
  return marketing ? 'currentMarketingFolder' : 'currentNonMarketingFolder';
}

function updateFolder(rootFolder, folder) {
  rootFolder.children = rootFolder.children.map((child) => {
    if (child.folder && (child.id == folder.id)) return folder;

    return child;
  });

  return rootFolder;
}

function updateDocumentInFolder(folder, document) {
  folder.children = folder.children.map((child) => {
    if (child.id == document.id) return document;

    return child;
  });
  return folder;
}

function addItemToFolder(folder, item) {
  const existingItem = findItemInFolder(folder, item.id, item.folder);

  if (existingItem) {
    if (item.folder) {
      updateFolder(folder, item);
    } else {
      updateDocumentInFolder(folder, item);
    }
  } else if (item.folderId == folder.id) {
    folder.children = [...folder.children, item];
  }

  return folder;
}

function filterFromFolder(folder, itemToRemove) {
  folder.children = folder.children.map((child) => {
    if (itemToRemove.folder === child.folder && child.id === itemToRemove.id) return false;

    return child;
  }).filter(item => item !== false);

  return folder;
}

function findItemInFolder(folderToSearch, itemId, isFolder) {
  let item;


  folderToSearch.children.forEach((child) => {
    if (!item) {
      if (child.id === itemId && !!child.folder === isFolder) {
        item = child;
      }
    }
  });

  return item;
}
